import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import Logo from "@/components/Logo";
import { COMPANY, SERVICES } from "@/config/site";

const Footer = () => {
  const year = new Date().getFullYear();

  const reopenCookies = () => {
    window.dispatchEvent(new CustomEvent("astrolog:open-cookies"));
  };

  return (
    <footer className="brand-dark noise relative" data-testid="footer">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div className="space-y-5">
            <Logo dark />
            <p className="text-sm leading-relaxed text-slate-400">
              Transport public routier de marchandises, location de véhicules
              industriels avec conducteurs et déménagement. France et Europe.
            </p>
            <div className="space-y-2 text-sm text-slate-400">
              <p className="flex items-start gap-2">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-secondary" />
                {COMPANY.fullAddress}
              </p>
              <p>
                <a
                  href={COMPANY.phoneHref}
                  data-testid="footer-phone-link"
                  className="flex items-center gap-2 transition-colors hover:text-secondary"
                >
                  <Phone className="h-4 w-4 shrink-0 text-secondary" />
                  {COMPANY.phone}
                </a>
              </p>
              <p>
                <a
                  href={COMPANY.emailHref}
                  data-testid="footer-email-link"
                  className="flex items-center gap-2 transition-colors hover:text-secondary"
                >
                  <Mail className="h-4 w-4 shrink-0 text-secondary" />
                  {COMPANY.email}
                </a>
              </p>
              <p className="flex items-start gap-2">
                <Clock className="mt-0.5 h-4 w-4 shrink-0 text-secondary" />
                {COMPANY.hours}
              </p>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold uppercase tracking-widest text-slate-500">
              Navigation
            </h3>
            <ul className="mt-5 space-y-3 text-sm">
              {[
                ["Accueil", "/"],
                ["Services", "/services"],
                ["Calculateur de devis", "/calculateur"],
                ["Notre flotte", "/flotte"],
                ["À propos", "/a-propos"],
                ["Contact", "/contact"],
              ].map(([label, to]) => (
                <li key={to}>
                  <Link
                    to={to}
                    className="text-slate-400 transition-colors duration-200 hover:text-accent"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold uppercase tracking-widest text-slate-500">
              Nos services
            </h3>
            <ul className="mt-5 space-y-3 text-sm">
              {SERVICES.map((s) => (
                <li key={s.id}>
                  <Link
                    to={`/services#${s.id}`}
                    className="text-slate-400 transition-colors duration-200 hover:text-accent"
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold uppercase tracking-widest text-slate-500">
              Informations légales
            </h3>
            <ul className="mt-5 space-y-3 text-sm">
              <li>
                <Link to="/mentions-legales" className="text-slate-400 transition-colors hover:text-accent">
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link to="/conditions-generales-de-vente" className="text-slate-400 transition-colors hover:text-accent">
                  Conditions générales de vente
                </Link>
              </li>
              <li>
                <Link to="/conditions-generales-utilisation" className="text-slate-400 transition-colors hover:text-accent">
                  Conditions générales d'utilisation
                </Link>
              </li>
              <li>
                <Link to="/politique-de-confidentialite" className="text-slate-400 transition-colors hover:text-accent">
                  Politique de confidentialité
                </Link>
              </li>
              <li>
                <button
                  type="button"
                  onClick={reopenCookies}
                  data-testid="manage-cookies-button"
                  className="text-slate-400 transition-colors hover:text-accent"
                >
                  Gérer mes cookies
                </button>
              </li>
            </ul>
            <p className="mt-6 text-xs leading-relaxed text-slate-500">
              {COMPANY.name} — SAS au capital de {COMPANY.capital}
              <br />
              {COMPANY.rcs} · TVA {COMPANY.tva}
            </p>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 text-xs text-slate-500 sm:flex-row">
          <p>© {year} {COMPANY.name}. Tous droits réservés.</p>
          <p>Site hébergé par Namecheap</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
